import { differenceInYears } from 'date-fns';

const isYoungerThan26 = (birthdate: string) => {
  return differenceInYears(new Date(), new Date(birthdate)) < 26;
};

export default isYoungerThan26;
